/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".dimension-activate{display:flex;flex-direction:row;flex-wrap:wrap}.dimension-activate .dimension-content{width:auto}.dimension-card{width:min(50vw,200px);margin-left:15px}#CompanyConfigurationDimensionEnableButton{margin:0}"];
export { styles as styles };
